<script lang="ts">
  import { onMount } from "svelte";
  import { cart } from "$lib/stores/cart";
  import Drawer from "$lib/components/Drawer/Drawer.svelte";
  import Popover from "$lib/components/Popover/Popover.svelte";
  import AddedToBasket from "./AddedToBasket.svelte";
  import MiniCartContent from "./MiniCartContent.svelte";
  import type { RegionStore } from "$lib/stores/region";
  import { minicart } from "$lib/stores/minicart";

  export let regionInfo: RegionStore;

  let popover: Popover;
  let drawer: Drawer;
  export let isOpen = $minicart.isOpen;

  let activeComponent: Drawer | Popover;

  $: activeComponent = isMobile ? drawer : popover;

  export const handleOpenMiniCart = () => {
    if (activeComponent && $cart?.lines?.edges?.length > 0)
      activeComponent.open();
  };

  export const handleCloseMiniCart = () => {
    if (activeComponent) activeComponent.startTimeout();
  };

  $: $minicart.isOpen ? handleOpenMiniCart() : handleCloseMiniCart();
  $: isOpen = $minicart.isOpen;

  let shouldStayOpen: boolean;

  export let disableAutoDismiss = false;

  $: shouldStayOpen = false;

  export const isMouseOver = (mouseOver: boolean) => {
    shouldStayOpen = mouseOver;
  };

  $: if ($cart?.lines?.edges?.length === 0 && activeComponent)
    activeComponent.close();

  let viewportWidth: number;
  let isMobile = false;
  let mdWidth = 766;

  $: viewportWidth >= mdWidth ? (isMobile = false) : (isMobile = true);

  onMount(() => {
    const bodyStyle = getComputedStyle(document.body);
    mdWidth = Number(bodyStyle.getPropertyValue("--md").replace(/\D/g, ""));
  });
</script>

<style lang="scss">
</style>

<svelte:window bind:innerWidth={viewportWidth} />

{#if isMobile}
  <Drawer bind:this={drawer} delay={2000} {isOpen} {disableAutoDismiss}>
    <AddedToBasket
      on:click={e => {
        e.preventDefault();
        activeComponent.close();
      }}
      close={activeComponent.close}
    />
    <MiniCartContent {isMobile} {regionInfo} />
  </Drawer>
{:else}
  <Popover
    bind:this={popover}
    delay={4000}
    {isOpen}
    fixed
    disableAutoDismiss={shouldStayOpen}
  >
    <MiniCartContent {isMobile} {regionInfo} />
  </Popover>
{/if}
